export default `float l, e, v;
  l=1.;
  for(int j=0;j++<8;l*=v)
    p=2.*clamp(p,-.8,.9)-p,
    p*=v=max(.9/dot(p,p),.7),
    p+=.13;
  return e=.1*p.y/l;
}`